/**
 * Firebase Cloud Messaging (Web Push) registration for the dashboard.
 *
 * `registerPush(sendToken)` is best-effort: it requests notification
 * permission, registers the service worker, gets an FCM token, and hands it to
 * the caller-supplied `sendToken` (which runs the `pushDeviceRegister` Apollo
 * mutation). Any unsupported-browser / denied-permission / error path is a
 * silent no-op so it never disrupts the app. The Firebase web config and VAPID
 * key below are public by design (they ship to the browser).
 */
import { getApps, initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBWsoL8uwdRLElwBnc446O5HzxFh0_g394",
  authDomain: "jbm-9856c.firebaseapp.com",
  projectId: "jbm-9856c",
  storageBucket: "jbm-9856c.firebasestorage.app",
  messagingSenderId: "112429897185",
  appId: "1:112429897185:web:513d6b7fe304b7990f6ea0",
};

const VAPID_KEY =
  "BIFhcGAwY5xd5eyo9bX7hmXf5_ldUstY4Z-tKw6qIXv5eB3FBmA5OdEizrIZJ5elGg3rfinDPk-fF7qrBYiDdJQ";

// Register at most once per page load (the bell effect can re-run).
let registered = false;

const app = () =>
  getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export async function registerPush(
  sendToken: (token: string) => Promise<unknown>,
): Promise<void> {
  try {
    if (
      registered ||
      typeof window === "undefined" ||
      !("serviceWorker" in navigator) ||
      !("Notification" in window)
    ) {
      return;
    }
    if (!(await isSupported())) return;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js",
    );
    const messaging = getMessaging(app());
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
    if (!token) return;

    registered = true;
    await sendToken(token);

    onMessage(messaging, () => {});
  } catch {
    // Best-effort: never surface push setup failures to the user.
  }
}
